import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { DataFields, DataTypes } from '../../types';
import { Role } from '../types';
import { ApiMasterDataType } from '../types-graphql';
import { handleGQLErrors } from '../utils';

export interface FieldsService {
  listAvailable: (dataType: DataTypes) => Promise<DataFields[]>;
}

export class BackendFieldsService implements FieldsService {
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly simulatedRole: Role | null
  ) {}

  public listAvailable = async (dataType: DataTypes) => {
    const res = (
      await handleGQLErrors(
        this.graphQlRequestService.graphQlSdk.listAvailableFields({
          datatype: dataType as unknown as ApiMasterDataType,
          simulateRole: this.simulatedRole?.id ?? null,
        })
      )
    ).listAvailableFields as DataFields[];
    return res ?? [];
  };
}
